

// import React from 'react';
import { useNavigate } from 'react-router-dom';
import logowithname from '../../Assets/Images/logowithname.svg';

const navLinks = [
  { label: 'Home',             url: '/' },
  { label: 'CareSathi',        url: '/caresathi' },
  { label: 'SmartVital',       url: '/smartvital' },
  { label: 'SkinCare',         url: '/skincare' },
  { label: 'LungsCare',        url: '/lungscare' },
  { label: 'OralCare',         url: '/oralcare' },
  { label: 'SmartReport',      url: '/smartReport' },
  { label: 'SmartDiet',        url: '/smartdiet' },
  { label: 'Symptom Checker',  url: '/symptomchecker' },
  { label: 'VisionCare',       url: '/visioncare' },
];

const socialLinks = [
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/80637697/admin/',
    bg: '#0A66C2',
    icon: (
      <svg width="16" height="16" fill="white" viewBox="0 0 24 24">
        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2zM4 6a2 2 0 100-4 2 2 0 000 4z"/>
      </svg>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://facebook.com/CureBay-106822021819382/',
    bg: '#1877F2',
    icon: (
      <svg width="16" height="16" fill="white" viewBox="0 0 24 24">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: 'https://instagram.com/cure_bay?utm_medium=copy_link',
    bg: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%)',
    icon: (
      <svg width="16" height="16" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <circle cx="12" cy="12" r="4"/>
        <circle cx="17.5" cy="6.5" r="0.5" fill="white" stroke="none"/>
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href: 'https://youtube.com/@curebayofficial?si=RnJBidaNnFV49cnt',
    bg: '#FF0000',
    icon: (
      <svg width="16" height="16" fill="white" viewBox="0 0 24 24">
        <path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 00-1.95 1.96A29 29 0 001 12a29 29 0 00.46 5.58A2.78 2.78 0 003.41 19.6C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.95A29 29 0 0023 12a29 29 0 00-.46-5.58z"/>
        <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#FF0000"/>
      </svg>
    ),
  },
];

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="cb-footer">

      <style>{`
        .cb-footer {
          width: 100%;
          font-family: 'Inter', sans-serif;
          background: #ffffff;
          border: 1px solid #A6E4F4;
          border-bottom: none;
          border-radius: 40px 40px 0 0;
          box-shadow: 4px 0px 10px 0px #80DAF180;
          overflow: hidden;
          box-sizing: border-box;
        }

        .footer-grid {
          display: grid;
          grid-template-columns: 37% 1fr auto;
          gap: 32px;
          padding: 48px max(72px, calc(50% - 648px)) 28px;
          align-items: start;
        }

        .footer-title {
          color: var(--color-brand-primary);
          font-size: 26px;
          font-weight: 600;
          line-height: 1.2;
          margin: 0 0 10px;
        }

        .footer-lead {
          color: var(--color-brand-primary);
          font-size: 15px;
          line-height: 1.6;
          margin: 0;
          max-width: 380px;
        }

        .footer-contact {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .footer-contact-row {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        .footer-contact-row svg { flex-shrink: 0; }

        .footer-contact-text {
          margin: 0;
          font-size: 14px;
          line-height: 1.5;
          color: var(--color-brand-primary);
        }

        .footer-right {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-self: end;
          gap: 16px;
        }

        .footer-socials { display: flex; gap: 12px; }

        .footer-social {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          text-decoration: none;
          transition: transform 0.15s;
        }
        .footer-social:hover { transform: translateY(-2px); }

        .footer-copy {
          margin: 0;
          color: var(--color-brand-primary);
          font-size: 12px;
        }

        /* logo centred between two divider lines */
        .footer-logo-row {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 0 72px 24px;
        }
        .footer-logo-row::before,
        .footer-logo-row::after {
          content: '';
          flex: 1;
          height: 1px;
          background: #80DAF1;
        }
        .footer-logo-row img { height: 56px; width: auto; }

        .footer-nav {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-around;
          align-items: center;
          border-top: 1px solid #A6E4F4;
          padding: 4px max(40px, calc(50% - 680px));
        }

        .footer-nav-item { display: flex; align-items: center; flex: 1 1 auto; }

        .footer-nav-btn {
          flex: 1;
          padding: 6px 16px;
          color: var(--color-brand-primary);
          font-size: 14px;
          font-weight: 500;
          background: none;
          border: none;
          cursor: pointer;
          white-space: nowrap;
          font-family: inherit;
          transition: color 0.15s;
        }
        .footer-nav-btn:hover { color: var(--color-brand-green); }

        .footer-nav-sep {
          width: 1px;
          height: 18px;
          background: #80DAF1;
          flex-shrink: 0;
        }

        @media (max-width: 1100px) and (min-width: 768px) {
          .footer-grid { grid-template-columns: 1fr 1fr auto; padding: 40px 32px 24px; gap: 24px; }
          .footer-title { font-size: 24px; }
          .footer-logo-row { padding: 0 32px 20px; }
          .footer-logo-row img { height: 48px; }
          .footer-nav { padding: 8px 16px; }
        }

        @media (max-width: 767px) {
          .cb-footer { border-radius: 24px 24px 0 0; }
          .footer-grid {
            grid-template-columns: 1fr;
            gap: 24px;
            padding: 28px 20px 20px;
          }
          .footer-title { font-size: 22px; margin-bottom: 10px; }
          .footer-lead { font-size: 14px; }
          .footer-contact-text { font-size: 13px; }
          .footer-contact { gap: 20px; }
          .footer-right { align-items: flex-start; justify-self: start; gap: 14px; }
          .footer-logo-row { padding: 0 20px 16px; }
          .footer-logo-row img { height: 40px; }
          .footer-nav { padding: 8px; }
          .footer-nav-item { flex: 0 0 auto; }
          .footer-nav-btn { padding: 6px 10px; }
        }
      `}</style>

      {/* ── MAIN BODY ── */}
      <div className="footer-grid">

        {/* LEFT — heading */}
        <div>
          <h3 className="footer-title">Contact Information</h3>
          <p className="footer-lead">
            We're here to help, reach out for support or inquiries anytime.
          </p>
        </div>

        {/* MIDDLE — contact rows */}
        <div className="footer-contact">
          <div className="footer-contact-row">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#004276" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81 19.79 19.79 0 01.12 2.18 2 2 0 012.11 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.09a16 16 0 006 6l.45-.45a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
            </svg>
            <div>
              <p className="footer-contact-text">Phone: +91-8335 000 999</p>
              <p className="footer-contact-text">Email: contact@curebay.com</p>
            </div>
          </div>

          <div className="footer-contact-row">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#004276" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            <p className="footer-contact-text">
              4th Floor, OCAC Tower, Acharya Vihar,<br />
              Bhubaneswar, Odisha – 751013.
            </p>
          </div>
        </div>

        {/* RIGHT — socials + copyright */}
        <div className="footer-right">
          <div className="footer-socials">
            {socialLinks.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                aria-label={s.label}
                className="footer-social"
                style={{ background: s.bg }}
              >
                {s.icon}
              </a>
            ))}
          </div>
          <p className="footer-copy">Copyright © {new Date().getFullYear()} • All Rights Reserved</p>
        </div>

      </div>

      <div className="footer-logo-row">
        <img
          src={logowithname}
          alt="CureBay"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      </div>

      {/* ── BOTTOM NAV BAR ── */}
      <nav className="footer-nav">
        {navLinks.map((link, i) => (
          <span key={link.label} className="footer-nav-item">
            <button className="footer-nav-btn" onClick={() => navigate(link.url)}>
              {link.label}
            </button>
            {i < navLinks.length - 1 && <span className="footer-nav-sep" aria-hidden="true" />}
          </span>
        ))}
      </nav>

    </footer>
  );
};

export default Footer;
